import React from "react";
import logoIcon from 'shared/images/logo_white.svg';
import logoText from 'shared/images/text_white.svg';
import "./MenuClientUsed.scss";

export default function MenuClientUsed() {
    return (
        <div className="week-already-used">
            <div className="__banner">
                <div className="__logo">
                    <img className="__icon" src={logoIcon} alt="Logo La Cigale"/>
                    <img className="__text" src={logoText} alt="La Cigale"/>
                </div>
            </div>
            <div className="__message">
                <h2>La semaine a été enregistrée.</h2>
                <p>Merci pour votre participation.</p>
            </div>
        </div>
    );
}
